<app-content-header i18n-title title="Booking Change Requests" i18n-subTitle
                    subTitle="An overview of all change requests"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>
<div class="content">
  <div class="row">
    <div class="col-md-3">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Filter</h3>
        </div>

        <!-- -->
        <div class="block-content block-content-full">
          <form [formGroup]="form" (ngSubmit)="loadChangeRequestsToCheck()">
            <div class="row">
              <label class="col-12" for="bookingChangeRequestId">State</label>
              <div class="col-12">
                <select class="form-control" formControlName="state">
                  <option value="">Please select..</option>
                  <option value="NEW">New</option>
                  <option value="PROCESSED">Processed</option>
                  <option value="DENIED">Denied</option>
                </select>
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="bookingChangeRequestId">Section</label>
              <div class="col-12">
                <select class="form-control" formControlName="section">
                  <option value="">Please select..</option>
                  <option value="GENERAL">General</option>
                  <option value="CANCELLATION">Cancellation</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="row">
              <label class="col-12" for="bookingChangeRequestId">ChangeRequestId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="ChangeRequestId"
                       autocomplete="off"
                       id="bookingChangeRequestId"
                       formControlName="bookingChangeRequestId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="bookingChangeRequestId">BookingId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="BookingId"
                       autocomplete="off"
                       id="bookingId"
                       formControlName="bookingId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="bookingChangeRequestId">RequestId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="RequestId"
                       autocomplete="off"
                       id="requestId"
                       formControlName="requestId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="bookingChangeRequestId">OfferId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="OfferId"
                       autocomplete="off"
                       id="offerId"
                       formControlName="offerId">
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button class="btn btn-info btn-sm" type="submit">Apply Filter</button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Change Requests</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Id</th>
                <th>BookingId</th>
                <th>OfferId</th>
                <th>RequestId</th>
                <th>Section</th>
                <th>State</th>
                <th>CreatedAt</th>
                <th>DealtWithAt</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody *ngIf="bookingChangeRequests != null && pagination != null">
              <tr *ngFor="let changeRequests of bookingChangeRequests | paginate: {
              itemsPerPage: pagination.limit,
              currentPage: pagination.page,
              totalItems: pagination.total}"
              >
                <td>{{changeRequests._id}}</td>
                <td>{{changeRequests.bookingId}}</td>
                <td>{{changeRequests.offerId}}</td>
                <td>{{changeRequests.requestId}}</td>
                <td>
                  <span class="badge badge-danger" *ngIf="changeRequests.section === 'CANCELLATION'">Cancellation</span>
                  <span class="badge badge-info" *ngIf="changeRequests.section === 'GENERAL'">General</span>
                </td>
                <td>
                  <span class="badge badge-warning" *ngIf="changeRequests.state === 'NEW'">New</span>
                  <span class="badge badge-success" *ngIf="changeRequests.state === 'PROCESSED'">Processed</span>
                  <span class="badge badge-danger" *ngIf="changeRequests.state === 'DENIED'">Denied</span>
                </td>
                <td>{{changeRequests.createdAt}}</td>
                <td>{{changeRequests.dealtWithAt}}</td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="requestChangeRequestDetails(changeRequests._id)">
                    Edit
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="block-content block-content-sm bg-body-light font-size-sm text-center">
          <pagination-controls [maxSize]="10"
                               (pageChange)="sendPage($event)"
                               *ngIf="pagination != null">

          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<tripmakery-booking-change-requests-edit-modal></tripmakery-booking-change-requests-edit-modal>
